export default "__VITE_ASSET__D_5I3ixk__"